import { render, staticRenderFns } from "./BlkAddlDesc.vue?vue&type=template&id=465441a2&"
import script from "./BlkAddlDesc.vue?vue&type=script&lang=js&"
export * from "./BlkAddlDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports